import React, { useEffect } from 'react';
import DetailPageTitleComponent from '../../../components/NewDesign/Misc/DetailPageTitle/DetailPageTitleComponent';
import DetailPageDescComponent from '../../../components/NewDesign/Misc/DetailPageDesc/DetailPageDescComponent';
import './ArticleComp.scss';
import AudioPlayer from './AudioPlayer';

const AudioPlayerComp = ({ setLoadFalse,link,moduleId,courseId,watch_time}) => {
  useEffect(()=>{
    setLoadFalse();
  },[])
    return (
         <div class="action-sec action-sec-inner mt-2rem mb-2rem">
                <div class="audio-box w-100">
                  <AudioPlayer src={link} moduleId = {moduleId} courseId = {courseId} watch_time={watch_time} />
                </div>
                </div>
    );
};

export default AudioPlayerComp;